import { RouteConfig } from "vue-router";

export const REmployeesBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "employees-browse" */
      "./VEmployeesBrowse.vue"
    ),
  meta: {
    title: "Employees",
    version: 2,
  },
};
